import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import NegotiationState from '../../../../../_shared/constants/negotiationState';
import TradeDetails from '../../../../../_shared/models/TradeDetails';
import StartNegotiationContainer from '../../../../ModalButton/NegotiationButton/StartNegotiationContainer';
import SendToClosingContainer from '../../../../ModalButton/NegotiationButton/SendToClosingContainer';

import { StyledSecondaryButton } from './Styles';
import PendingFooterContext from '../PendingFooterContext';

const PendingFooterButton = ({ tradeDetails, isOmp }) => {
  const { negotiations, negotiationState } = useContext(PendingFooterContext);
  const trade = TradeDetails.asPendingTrade(tradeDetails, negotiationState);

  switch (negotiationState) {
    case NegotiationState.NO_NEGOTIATION:
      return (
        <StartNegotiationContainer
          trade={trade}
          tradeDetails={tradeDetails}
          Button={({ onClick }) => (
            <StyledSecondaryButton onClick={onClick}>
              <FormattedMessage id="vdp.pending.seller.button.startNegotiation" />
            </StyledSecondaryButton>
          )}
          isOmp={isOmp}
        />
      );
    case NegotiationState.BUYER_OFFER:
      return (
        <SendToClosingContainer
          trade={trade}
          topBid={negotiations?.topBid}
          isInternalTrade={tradeDetails?.isInternalTrade}
          Button={({ onClick }) => (
            <StyledSecondaryButton onClick={onClick}>
              <FormattedMessage id="vdp.pending.seller.button.sendToClosing" />
            </StyledSecondaryButton>
          )}
        />
      );
    default:
      return null;
  }
};

export default PendingFooterButton;
